import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {patchBulkStoreAdvertisement} from './patchBulkStoreAdvertisement';

export interface IPatchBulkStoreAdvertisement {
  ad_price: number;
  id: string;
}
const usePatchBulkStoreAdvertisement = (
  handleAfterSuccess?: (variables: IPatchBulkStoreAdvertisement[]) => void,
) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPatchBulkStoreAdvertisement[]) =>
      patchBulkStoreAdvertisement(payload),

    onSuccess: (_, variables) => {
      // pass variables out
      handleAfterSuccess?.(variables);
      queryClient.invalidateQueries(['get-my-store-ads']);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePatchBulkStoreAdvertisement;
